module.exports = __webpack_public_path__ + "img/discussionComments.6beae29e.svg";